import { render, staticRenderFns } from "./InvalidLink.vue?vue&type=template&id=91619d3c&"
import script from "./InvalidLink.vue?vue&type=script&lang=ts&"
export * from "./InvalidLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports